<template>
  <div>
    <transition name="menu-popover">
      <div v-if="showDetails == true" class="lightbox">
        <h2 class="closeX" @click="closeLightbox()">
          <a>&#215;</a>
        </h2>

        <section class="py-5 bs-shadow mobile-top overlay-card" style="background: #fff; text-align: left; padding: 40px; border-radius: 5px; position: relative;">
          <h2 @click="closeLightbox()" style="    position: absolute; top: 0px; right: 10px; cursor: pointer;">
          <a>&#215;</a>
        </h2>
      <div class="container">
        <h4 class="mb5"><b>Attendee Details</b></h4>
        <div>
          <div style="margin-right: 20px">
            <div>
              <p class="mb5">
                <b>Name:</b> {{ userDetails.First_Name + " " + userDetails.Last_Name}}
              </p>
              <p class="mb5">
                <b>Name Preference:</b> {{ userDetails.Name_Preference }}
              </p>
              <p class="mb5">
                <b>Job Title:</b> {{ userDetails.Job_Title }}
              </p>
              <p class="mb5">
                <b>Rep ID:</b> {{ userDetails.RepID }}
              </p>





              <p class="mb5">
                <b>Email:</b> {{ userDetails. Email }}
              </p>
              <p class="mb5">
                <b>Phone Number:</b> {{ userDetails.Phone_Number }}
              </p>
              <p class="mb5">
                <b>Company:</b> {{ userDetails.Company }}
              </p>
              <p class="mb5">
                <b>Company Address:</b> {{ userDetails.Company_Street }}
              </p>
              <p class="mb5">
                <b>Company Address:</b> {{ userDetails.Company_City + ", " + userDetails.Company_State + " " + userDetails.Company_Zip}}
              </p>
              <p class="mb5">
                <b>Employed Fulltime:</b> {{ userDetails.Fulltime ? "Yes" : "No"}}
              </p>
              <p class="mb5">
                <b>Time Employed:</b> {{ userDetails.Time_Employed }}
              </p>
              <p class="mb5">
                <b>Worked for Competitors:</b> {{ userDetails.Worked_For_Competitors ? "Yes" : "No" }}
              </p>
              <p class="mb5" v-if="userDetails.Worked_For_Competitors">
                <b>Competitor:</b> {{ userDetails.Competitor }}
              </p>
              <p class="mb5">
                <b>Hotel Required:</b> {{ userDetails.HotelRequired ? "Yes" : "No"}}
              </p>
              <p class="mb5">
                <b>Arrival:</b> {{ formatDates(userDetails.Arrival) }}
              </p>
              <p class="mb5">
                <b>Departure:</b> {{ formatDates(userDetails.Departure) }}
              </p>
              <p class="mb5">
                <b>Dietary Requirements:</b> {{ userDetails.Dietary_Requirements ? "Yes" : "No" }}
              </p>
              <p class="mb5" v-if="userDetails.Dietary_Requirements">
                <b>Requirement:</b> {{ userDetails.Requirement }}
              </p>

  
<!--
           DateEntered: this.formatDates(item.DateEntered),           
-->
  
              
              
        <!--
            
              
              
              
              
              
              
              
              Arrival
              Departure
              HotelRequired
              Dietary_Requirements
              Requirement
              RepID  
        -->     
              
            </div>
          </div>
         
        </div>
      </div>
    </section>


      </div>
    </transition>
    <div class="page-listings">
        <section class="py-5 banner-bg bs-shadow mobile-top">

        <div class="container">
          <div style="display: flex;">
          <h1 class="text-white mb0 lh1">Product School Registrants</h1>
          <a data-v-0f710401="" v-if="$store.getters.isSpacesaverEmployee" href="/product-school-report" class="search" style="min-width: 120px; padding-left: 10px; margin-left: auto; color: fff; text-decoration: none;">User Report <i data-v-0f710401="" class="material-icons">keyboard_arrow_right</i></a>
        </div>

        <hr class="header-divide" />
        <div class="search-btns">
          <div class="left-side" style="margin-right: 20px">
            <div>
      
              <h5 className="text-white mb-[10px]">The Product School Registrants dataset contains information about individuals registered for an event, including their personal details, job titles, contact information, company data, and event-specific details such as arrival and departure times.</h5>
    
              
              <div class="row">
                <div class="col-xs-12 col-12">


                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      <section id="ScrollTarget" class="py-5 bs-shadow mobile-top">
        
        <div v-if="loading == true" class="container" style="margin-top:100px;">
        <div
                
                class="col-xs-12 col-sm-12 col-12 col-lg-12"
              >
                <div class="flex-box-wrap">
                  <div class="flex-internal">
                    <atom-spinner
                      :animation-duration="1000"
                      :size="40"
                      :color="'#575757'"
                    />
                    <p>Loading......</p>
                  </div>
                </div>
              </div>
            </div>
        
        <div v-else data-v-5a90ec03 class="container">
          <SimplePagination
            :currPage="currPage"
            :totalPage="totalPage"
            :filteredPosts="filteredListings"
            :setPage="setPage"
          />
          
      
  
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            :duration="500"
            mode="out-in"
            appear
          >
          <div>
            <div class="step1" key="step1">
              <div class="listing">
            
                <div class="d-flex" style="margin-bottom: 20px">

               
              
                <a href="/product-school" style="display: flex;" class="mb0 lh1 mrauto list-btn dib d-flex center"><i class="material-icons">keyboard_arrow_left</i> Back</a>
                <download-csv
                  class="mb0 lh1 mlauto list-btn dib d-flex center"
                  :data="formattedData"
                  :name="'product-scool-attendees' + '.csv'"
                  >Download CSV</download-csv
                >
                </div>
                <hr />
                <div class="row">

                  <div class="col col-12">
              


                <table
                      class="table-striped table-bordered"
                      style="display: table; width: 100%;"
                    >
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            class="table-link ten"
                            @click="sortCol('Attendance')"
                            :class="
                              columnSort == 'Attendance'
                                ? 'column-active'
                                : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span class="mr-auto">Class Date</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'Attendance'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="table-link twenty"
                            @click="sortCol('Last_Name')"
                            :class="
                              columnSort == 'Last_Name' ? 'column-active' : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span>Name </span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'Last_Name'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="table-link ten"
                            @click="sortCol('Job_Title')"
                            :class="
                              columnSort == 'Job_Title' ? 'column-active' : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span>Job Title</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'Job_Title'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="table-link twenty"
                            @click="sortCol('Email')"
                            :class="
                              columnSort == 'Email'
                                ? 'column-active'
                                : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span class="mr-auto">Email</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'Email'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="table-link thirty"
                            @click="sortCol('Company')"
                            :class="
                              columnSort == 'Company' ? 'column-active' : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span>Company</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'Company'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>

                        







               
                        </tr>
                      </thead>

                      <tbody>
                     
                        <tr
                          scope="row"
                          v-bind:key="index"
                          v-for="(entry, index) in paginatedPosts"
                        >
                        <td>
                            {{$moment(entry.Attendance).format("MM-DD-YYYY")}}
                  
                          </td>
                          <td>
                            <span @click="showLightbox(entry)" class="name-link">{{entry.First_Name + " " + entry.Last_Name}}</span>
                          </td>
                          <td>
                            {{ entry.Job_Title }}
                          </td>
                          <td>{{ entry.Email }}</td>
                          <td
                        
                          >{{ entry.Company }}</td>
                       

                         


             

                      
                        
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                     <div class="row">
                <div class="col col-12">
                  <div
                    class="
                      nav-btns
                      listing-header
                      d-flex
                      align-items-center
                      mt10
                      mb10
                      rounded
                      b-shadow
                    "
                  >
  
  
  

                  </div>
                </div>
              </div>
              </div>
              <SimplePagination
                    class="mt20"
                    :currPage="currPage"
                    :totalPage="totalPage"
                    :filteredPosts="filteredListings"
                    :setPage="setPage"
                  />
            </div>
            </div>
          </transition>
        </div>
      </section>
    </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { AtomSpinner } from "epic-spinners";
  // import Avatar from "vue-avatar";
  // import Datepicker from "vuejs-datepicker";
  import VueDatePicker from '@vuepic/vue-datepicker';
  import Multiselect from "vue-multiselect";
  import { HollowDotsSpinner } from "epic-spinners";
  import Banner1 from "../components/Banners/banner1.vue";
  import vSelect from "vue-select";
  import JsonCSV from "vue-json-csv";
  import BackButton from '@/components/Buttons/BackButton.vue';
  import SimplePagination from "@/components/Pagination/SimplePagination.vue";
  import { jwtDecode } from "jwt-decode";
  import "vue-select/dist/vue-select.css";
  import "vue-multiselect/dist/vue-multiselect.min.css";
  // import "animate.css";
  
  const auth = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    },
  };
  
  export default {
    name: "ProductSchool",
    components: {
      AtomSpinner,
      // Avatar,
      // Datepicker,
      VueDatePicker,
      Multiselect,
      HollowDotsSpinner,
      Banner1,
      vSelect,
      JsonCSV,
      BackButton,
      SimplePagination,
    },
    data() {
      return {
        ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
        server: import.meta.env.VITE_APP_SERVER_URL,
        backend: import.meta.env.VITE_APP_SERVER_URL,
        registrants: null,
        firstName: null,
        lastName: null,
        namePreference: "",
        jobTitle: "",
        PhoneNumber: "",
        Email: "",
        Company: null,
        companyAddress: "",
        companyCity: "",
        companyState: "",
        companyZip: "",
        country: "United States", // Default value for country dropdown
        shirt: "",
        hasWorkedForCompetitors: false,
        competitorName: "",
        noHotelRequired: false, // Radio button value for hotel
        hasDietaryRestrictions: false, // Radio button value for dietary 
        dietaryRequirement: "",

        RepId: null,
        ACID: null,      
        loading: true,    
        countOfPage: 25,
        currPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        check1: false,
        check2: false,
        check3: false,
        submitted: false,
        userDetails: null,
        showDetails: false,
        colSort: false,
        columnSort: "",

             
      };
    },
    methods: {  
      firstLoad: function () {
    
        this.loading = true;
        this.$store.commit("setActivePage", "order-manage");
        //return axios.get(this.endPointCompute, auth).then((response) => {
        return axios
          .get(`${this.backend}/api/v1/this-year-product-school`, auth)
          .then((response) => {
            if (response.status === 401) {
              this.$router.push("/");
          } else {
            console.log(response);
            this.registrants = response.data;
            this.loading = false;
          }
          });
      },

      setPage: function (idx) {
          if (idx <= 0 || idx > this.totalPage) {
            return;
          }
          this.currPage = idx;
          const newQuery = {
              ...this.$route.query, 
              page: idx, 
          };
          this.$router.push({ query: newQuery });
      },

      formatDates(isoString) {
        if (!isoString) return '--'; // Handle null or undefined
        try {
          const date = new Date(isoString);
          if (isNaN(date.getTime())) return '--'; // Handle invalid dates
          return date.toLocaleString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        } catch {
          return '--'; // Fallback for any parsing errors
        }
      },

      showLightbox(entry){
        console.log(entry)
        this.showDetails = true;
        this.userDetails = entry
      },
      closeLightbox(){
        this.showDetails = false;
        this.userDetails = null;
      },

      sortCol: function (type) {
      console.log(type);
      

      this.columnSort = type;
      const COLUMN = type;

      if (this.colSort) {
          this.filteredListings.sort((a, b) => (a[COLUMN] > b[COLUMN] ? 1 : -1));
        } else {
          this.filteredListings.sort((a, b) => (a[COLUMN] < b[COLUMN] ? 1 : -1));
      }


      this.colSort = !this.colSort;
      this.columnSort = "";
    
    },
  
      formatDate(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
  
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
  
        return [year, month, day].join("-");
      },
  
      setPage(idx) {
        if (idx <= 0 || idx > this.totalPage) return;
        this.currPage = idx;
        this.$router.push({ query: { ...this.$route.query, page: idx } });
      },
    },
    computed: {

      filteredListings: function () {
        //set the current page to 0
        // this.currPage = 1;
        //if the search box is filled in
        return this.registrants;

      },
      paginatedPosts() {
        return this.filteredListings.slice(this.pageStart, this.pageStart + this.countOfPage);
      },

      totalPage: function () {
        return Math.ceil(this.registrants.length / this.countOfPage);
      },

      pageStart: function () {
        return (this.currPage - 1) * this.countOfPage;
      },

      formattedData() {
        return this.registrants.map((item) => ({
          // ...item,
          Session: this.formatDates(item.Attendance),
          RepID: item.RepID,
          First_Name: item.First_Name,
          Last_Name: item.Last_Name,
          Name_Preference: item.Name_Preference,
          Job_Title: item.Job_Title,
          PhoneNumber: item.Phone_Number,
          Email: item.Email,
          Company: item.Company,
          Company_Street: item.Company_Street,
          Company_City: item.Company_City,
          Company_State: item.Company_State,
          Company_Zip: item.Company_Zip,
          Fulltime: item.Fulltime,
          Time_Employed: item.Time_Employed,
          Worked_For_Competitors: item.Worked_For_Competitors,
          Competitor: item.Competitor,
          HotelRequired: item.HotelRequired,
          dietaryRequirements: item.dietaryRequirements,
          Requirement: item.Requirement,
          Shirt: item.Shirt,
          Arrival: this.formatDates(item.Arrival),
          Departure: this.formatDates(item.Departure),
          DateEntered: this.formatDates(item.DateEntered),
        }));
      },
      activeNav() {
        return this.$store.state.activePage;
      },
      colorGetter() {
        return this.$store.state.colors;
      },
       checkFirst: function(){
         if(this.contactName.length){
           let fullName = this.contactName.split(' ');
           return fullName[0]
         } else {
           return '';
         }
      },
  
      checkLast: function(){
         if(this.contactName.length){
           let fullName = this.contactName.split(' ');
           return fullName[1]
         } else {
           return '';
         }
      },
      progressWidth: function () {
        let className = "first-step";
        if (this.step == 1) {
          let className = "first-step";
          return className;
        } else if (this.step == 2) {
          let className = "second-step";
          return className;
        } else if (this.step == 3) {
          let className = "third-step";
          return className;
        } else if (this.step == 4) {
          let className = "fourth-step";
          return className;
        } else if (this.step == 5) {
          this.removeDollarSign();
          let className = "fifth-step";
          return className;
        }
      },
      progressWidthComplex: function () {
        let className = "zero";
        if (this.step == 1) {
          let className = "first-step";
          return className;
        } else if (this.step == 2) {
          let className = "second-step";
          return className;
        } else if (this.step == 3) {
          let className = "third-step";
          return className;
        }  else if (this.step == 4) {
          let className = "fourth-step";
          return className;
        } else if (this.step == 5) {
          let className = "fifth-step";
          return className;
        }
      },
       progressPercentage: function () {
        if (this.step == 1) {
          return "20%";
        } else if (this.step == 2) {
          return "60%";
        } else if (this.step == 3) {
          return "90%";
        } else if (this.step == 4) {
          return "100%";
        } else if (this.step == 5) {
          return "90%";
        } 
      },
      companyID() {
        let number = this.$store.state.user.ACId[0];
        this.acid = number;
      },
      states() {
        return new Set(this.acList.map((x) => x.State).sort());
      },
    },
    created() {
      this.$store.commit("showNavigation");
      // console.log(this.$route.path);
    },
    mounted() {
      this.firstLoad();
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  #pickDate1 input {
    border: 0 !important;
    outline: none !important;
  }
  
  .btn-primary:not(:disabled):not(.disabled).active,
  .btn-primary:not(:disabled):not(.disabled):active,
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #00b4b4;
    border-color: #00b4b4;
  }
  
  .leadTime {
    background-color: #fff;
    line-height: 44px;
    padding: 20px;
    margin-bottom: 5px;
    border-top: 0;
  }
  .top-wrap {
    display: flex;
    align-items: flex-start;
  }
  .leadTime-bottom {
    align-items: flex-end;
  }
  .leadTime-header {
    background: #fff;
    color: #575757;
    display: flex !important;
  }
  .small-lh {
    line-height: 1.4em;
  }
  
  .listing {
    overflow: none;
  }
  
  .listing {
    background-color: #fff;
    line-height: 1;
    padding: 20px;
    margin-bottom: 5px;
    border-top: 0;
  }
  
  .table-responsive {
    display: table;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.03) !important;
  }
  .table-bordered td,
  .table-bordered th {
    border: 1px solid #e8e8e8 !important;
  }
  .badge-success {
    color: #fff;
    background-color: #4d5967;
    background-color: #1eb5b6;
  }
  .table-striped a {
    color: #00b4b4;
  }
  .table-striped td,
  .table-striped th {
    padding: 5px;
    font-weight: 300 !important;
  }
  .listing {
    border-radius: 4px;
  }
  table td {
    line-height: 1;
  }
  .table-striped th {
    background: #00b4b4;
    background: #4d5967;
    color: #fff;
  }
  .table-striped {
    min-width: 100%;
    overflow: scroll;
  }
  .search-btns {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .search-btns button {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: #4d5967;
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    cursor: pointer;
    max-height: 40px;
  }
  .search-btns .clear {
    margin-left: auto;
  }
  .search-btns .search {
    margin-left: 5px;
  }
  .search-btns button span {
    font-size: 20px;
    width: 20px;
    height: 20px;
    color: #fff;
  }
  .search-btns button:hover {
    background: #586575;
  }
  .search-btns button:active {
    background: #586575;
  }
  .search-btns button:disabled {
    opacity: 0.6;
    cursor: unset !important;
  }
  .search-btns button:disabled:hover {
    background: #4d5967;
  }
  .search-btns button:disabled:active {
    background: #4d5967;
  }
  
  @media all and (min-width: 768px) {
    .dates {
      display: flex;
      color: #757575 !important;
    }
  }
  .top-search {
    color: #757575;
  }
  select.form-control:not([size]):not([multiple]) {
    height: auto !important;
    padding: 10px !important;
    color: #757575;
  }
  .all-contractors {
    color: #757575 !important;
  }
  .header-divide {
    border-top: 1px solid rgba(255, 255, 255, 0.5);
  }
  .table-striped td:last-of-type {
    text-align: right;
  }
  .table-striped th:last-of-type {
    text-align: right;
  }
  .table-bordered td:first-of-type {
    border-right: none !important;
  }
  .table-bordered th:first-of-type {
    border-right: none !important;
  }
  .table-bordered td:last-of-type {
    border-left: none !important;
  }
  .table-bordered th:last-of-type {
    border-left: none !important;
  }
  .m50 {
    margin: 50px 0;
  }
  .nav-btns {
    display: flex;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease-out;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .slide-leave-active,
  .slide-enter-active {
    transition: 1s;
  }
  .slide-enter {
    transform: translate(100%, 0);
  }
  .slide-leave-to {
    transform: translate(-100%, 0);
  }
  .listing-header {
    background: #fff;
    color: #575757;
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .loader {
    margin: 0 auto 20px;
    width: 100%;
    height: 25px;
    border-radius: 14px;
    border-bottom: 1px solid #fff;
    border-top: 1px solid #999;
    background: #ccc;
    overflow: hidden;
    position: relative;
  }
  
  .progress-bar {
    height: inherit;
    width: 0%;
    border-radius: inherit;
    position: relative;
    overflow: hidden;
  }
  
  .progress-stripes {
    width: inherit;
    height: inherit;
    font-size: 180px;
    font-weight: bold;
    margin-top: -50px;
    letter-spacing: -14px;
  }
  
  .percentage {
    position: absolute;
    top: 0;
    right: 5px;
    font-weight: bold;
    font-size: 16px;
  }
  /* PURPLE */
  .teal .progress-bar {
    background: #00bcbc;
  }
  .teal .progress-stripes {
    color: #00b4b4;
  }
  .teal .percentage {
    color: #eee;
  }
  .first-step {
    width: 20%;
  }
  .second-step {
    width: 60%;
  }
  .third-step {
    width: 90%;
  }
  .fourth-step {
    width: 100%;
  }
  .fifth-step {
    width: 90%;
  }
  .teal {
    color: #00b4b4;
  }
  .lookup-wrapper {
    text-align: center;
  }
  .lookup-svg {
    width: 300px;
    height: auto;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-right: auto;
    margin: 0 auto;
  }
  .show-all-btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: rgb(124, 124, 129);
  
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 20px;
  }
  .show-all-btn:hover {
    background: #4d5967;
  }
  .custom-control-label:before {
    background-color: #dedede;
  }
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #00b4b4 !important;
  }
  input:focus {
    border-color: #00BCBC;
  }
  textarea:focus {
    border-color: #00BCBC;
  }
  .name-link{
    cursor: pointer; 
    color: #00b4b4;
  }
  .name-link:hover{
    text-decoration: underline;
  }
  .overlay-card {
    min-width: 500px;
  }
  </style>
  <style>
  .style-chooser .vs__selected{
        background-color: #00BCBC!important;
        color: #fff!important;
  }
  .style-chooser .vs__dropdown-option--highlight{
      background-color: #00BCBC!important;
      color: #fff!important;
  }
  .style-chooser .vs__selected-options{
    padding: 10px;
  }
  .style-chooser .vs__dropdown-option .vs__dropdown-option--highlight{
    background-color: #00BCBC!important;
    color: #fff!important;
  }
  .style-chooser .vs__deselect{
    fill: #fff;
  }
  .style-chooser .vs__selected{
    border: none;
    font-weight: 300;
    padding: 2px 10px;
  }
  .style-chooser .vs__dropdown-toggle{
    padding: 0;
  }
  .style-chooser .vs__search{
    margin: 0;
    padding: 0;
  }
  
  element.style {
  }
  .form-control {
      display: block;
      width: 100%;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
  textarea {
      overflow: auto;
      resize: vertical;
  }
  button, input, optgroup, select, textarea {
      margin: 0;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
  }
  *, ::after, ::before {
      box-sizing: border-box;
  }
  user agent stylesheet
  textarea {
      box-sizing: border-box;
  }
  .success-header{
    background: #00b4b4;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    padding: 50px;
  }
  .success-header img{
      max-width: 200px;
      
  }
  .failure-header{
    background: #5a6877;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    padding: 50px;
  }
  .failure-header img{
      width: 200px;
      
  }
  .success-body{
    text-align: center;
    padding: 50px;
  }
  .failure-body{
    text-align: center;
    padding: 50px;
  }
  .failure-body a{
    color: #00BCBC;
  }
  .failure-body p {
    margin-bottom: 5px;
  }
  .orange{
    color:#f16232
  }
  .header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.banner-bg {
background-color: #00BCBC;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg id='c'%3E%3Cg id='b'%3E%3Cuse href='%23a' y='-1400'/%3E%3Cuse href='%23a' y='-1300'/%3E%3Cuse href='%23a' y='-1200'/%3E%3Cuse href='%23a' y='-1100'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-900'/%3E%3Cuse href='%23a' y='-800'/%3E%3Cuse href='%23a' y='-700'/%3E%3Cuse href='%23a' y='-600'/%3E%3Cuse href='%23a' y='-500'/%3E%3Cuse href='%23a' y='-400'/%3E%3Cuse href='%23a' y='-300'/%3E%3Cuse href='%23a' y='-200'/%3E%3Cuse href='%23a' y='-100'/%3E%3Cg stroke='%2300B4B4' stroke-width='0' id='a'%3E%3Cpath fill='%2300B4B4' d='M0 0l2100 40l-2100 40z'/%3E%3C/g%3E%3Cuse href='%23a' y='100'/%3E%3Cuse href='%23a' y='200'/%3E%3Cuse href='%23a' y='300'/%3E%3Cuse href='%23a' y='400'/%3E%3Cuse href='%23a' y='500'/%3E%3Cuse href='%23a' y='600'/%3E%3Cuse href='%23a' y='700'/%3E%3Cuse href='%23a' y='800'/%3E%3Cuse href='%23a' y='900'/%3E%3Cuse href='%23a' y='1000'/%3E%3Cuse href='%23a' y='1100'/%3E%3Cuse href='%23a' y='1200'/%3E%3Cuse href='%23a' y='1300'/%3E%3Cuse href='%23a' y='1400'/%3E%3Cuse href='%23a' y='1500'/%3E%3Cuse href='%23a' y='1600'/%3E%3Cuse href='%23a' y='1700'/%3E%3Cuse href='%23a' y='1800'/%3E%3Cuse href='%23a' y='1900'/%3E%3Cuse href='%23a' y='2000'/%3E%3Cuse href='%23a' y='2100'/%3E%3Cuse href='%23a' y='2200'/%3E%3Cuse href='%23a' y='2300'/%3E%3Cuse href='%23a' y='2400'/%3E%3Cuse href='%23a' y='2500'/%3E%3Cuse href='%23a' y='2600'/%3E%3Cuse href='%23a' y='2700'/%3E%3Cuse href='%23a' y='2800'/%3E%3C/g%3E%3Cuse href='%23b' x='-1' transform='scale(-1 1)'/%3E%3C/g%3E%3Cuse href='%23c' x='' transform='rotate(90 0 0)' style='transform-origin:center'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
background-attachment: fixed;
background-size: cover;
}

.myTest .custom-control-input {
  margin-top: 0; /* Remove default offset */
}

/* Ensure label text aligns properly */
.myTest .custom-control-label {
  display: flex;
  align-items: center; /* Center the <small> text vertically within the label */
}

/* Adjust <small> styling if needed */
.myTest .form-text {
  margin-top: 0; /* Preserve original inline style */
  line-height: 1.5; /* Improve text alignment */
}

table td{
  word-break: break-word;
}
  </style>
  